import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PageRoute from "./components/PageRoute";
import Home from "./pages/Home";
import Contacts from "./pages/Contacts";
import { HeadProvider } from "react-head";
import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
import i18n from "./i18n"; // импортируем i18n, чтобы получить объект

export default function App() {

  return (
    <HeadProvider>
      <BrowserRouter>
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/:section" element={<Home />} />
          <Route path="*" element={<h1>Страница не найдена</h1>} />
        </Routes>


      </BrowserRouter>
    </HeadProvider>
  );
}
